class ProductImageZoom {
  constructor() {
    this.init();
    
    // Re-init if the media gallery is updated (e.g., variant change)
    document.addEventListener('shopify:section:load', this.init.bind(this));
    
    // Setup resize listener to handle breakpoint changes
    this.handleResize = this.handleResize.bind(this);
    window.addEventListener('resize', this.handleResize);
  }

  init() {
    // Target both .product-media (horizon) and .product__media (dawn/reference) containers
    this.containers = document.querySelectorAll('.product-media, .product__media, .product__modal-opener');
    if (!this.containers.length) return;

    this.containers.forEach(container => {
      // Find the image inside the container
      const img = container.querySelector('img.product-media__image, img.image-zoom-effect, img');
      if (!img) return;

      // Get high res url from either data-max-resolution or data-zoom
      const highResUrl = img.dataset.maxResolution || img.dataset.zoom || img.src;
      
      if (highResUrl) {
        // Store URL on container so we don't have to look it up on every move
        container.dataset.zoomUrl = highResUrl;
        
        // Remove existing listeners if any (prevent duplicates)
        container.removeEventListener('mouseenter', this.handleMouseEnter);
        container.removeEventListener('mousemove', this.handleMouseMove);
        container.removeEventListener('mouseleave', this.handleMouseLeave);
        container.removeEventListener('dblclick', this.handleDoubleClick);
        container.removeEventListener('touchend', this.handleTouchEnd);
        
        // Bind functions so we can remove them later
        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
        this.handleDoubleClick = this.handleDoubleClick.bind(this);
        this.handleTouchEnd = this.handleTouchEnd.bind(this);

        container.addEventListener('mouseenter', this.handleMouseEnter);
        container.addEventListener('mousemove', this.handleMouseMove);
        container.addEventListener('mouseleave', this.handleMouseLeave);
        container.addEventListener('dblclick', this.handleDoubleClick);
        container.addEventListener('touchend', this.handleTouchEnd);
      }
    });
  }

  handleResize() {
    if (window.innerWidth < 992) {
      this.removeZoomElements();
    } else {
      this.init(); // re-bind if passing breakpoint
    }
  }

  handleMouseEnter(e) {
    if (window.innerWidth < 992) return;
    
    const container = e.currentTarget;
    this.removeZoomElements(); // Ensure clean state
    
    const highResUrl = container.dataset.zoomUrl;
    if (!highResUrl) return;

    // Create Result Box
    this.zoomResult = document.createElement('div');
    this.zoomResult.className = 'product-zoom-result';
    this.zoomResult.style.backgroundImage = `url('${highResUrl}')`;
    
    // Append to body to prevent any overflow clipping issues from sliders
    document.body.appendChild(this.zoomResult);

    // Position the zoom box precisely to the right of the image
    const rect = container.getBoundingClientRect();
    this.zoomResult.style.position = 'fixed';
    this.zoomResult.style.top = `${rect.top}px`;
    this.zoomResult.style.left = `${rect.right + 20}px`; // 20px gap
    this.zoomResult.style.width = `450px`; // Fixed width for smaller box
    this.zoomResult.style.height = `450px`; // Fixed height for smaller box

    // Force reflow and add active class for fade in
    void this.zoomResult.offsetWidth; 
    this.zoomResult.classList.add('is-active');
  }

  handleMouseMove(e) {
    if (!this.zoomResult || window.innerWidth < 992) return;

    const container = e.currentTarget;
    const rect = container.getBoundingClientRect();

    // Calculate mouse position as a percentage of the container dimensions
    let x = e.clientX - rect.left;
    let y = e.clientY - rect.top;

    let xPercent = (x / rect.width) * 100;
    let yPercent = (y / rect.height) * 100;

    // Keep percentages within 0-100%
    xPercent = Math.max(0, Math.min(100, xPercent));
    yPercent = Math.max(0, Math.min(100, yPercent));

    this.zoomResult.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
  }

  handleTouchEnd(e) {
    if (window.innerWidth >= 992) return;
    const currentTime = new Date().getTime();
    const tapLength = currentTime - (this.lastTap || 0);
    if (tapLength < 300 && tapLength > 0) {
      // Double tap detected
      this.handleDoubleClick(e);
      // Don't preventDefault here to allow native events if needed, but the slider will open
    }
    this.lastTap = currentTime;
  }

  handleDoubleClick(e) {
    const container = e.currentTarget;
    const parentNode = container.closest('li, .product-media-container, .product__media-item, slideshow-slide') || container.parentElement;
    
    // Look for the native zoom trigger button
    const zoomBtn = parentNode.querySelector('.hidden-zoom-trigger, .product__media-toggle');
    if (zoomBtn) {
      zoomBtn.click();
    } else if (container.tagName.toLowerCase() === 'button' || container.classList.contains('product__modal-opener')) {
      container.click();
    }
  }

  handleMouseLeave() {
    this.removeZoomElements();
  }

  removeZoomElements() {
    if (this.zoomResult) {
      this.zoomResult.classList.remove('is-active');
      const el = this.zoomResult;
      // Remove after transition
      setTimeout(() => {
        if (el && el.parentNode) {
          el.parentNode.removeChild(el);
        }
      }, 300); // matches CSS transition time
      this.zoomResult = null;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ProductImageZoom();
});
